import { useState, useEffect, useMemo} from "react";
import { hasAccess } from "../../utils/permissions";
import { mergedContent } from "../../utils/mergeContentByLevel";
import { transformLevelContent } from "../transformLevelContent";
//import { getAccessibleLevels } from "../accessibleLevels";

export default function useLevelSelection(user, translatedData, courseSlug ) {
  const [selectedLevel, setSelectedLevel] = useState(null);

  const transformedData = useMemo(
    () => transformLevelContent(translatedData || []),
    [translatedData]
  );
  const allMerged = useMemo(
    () => mergedContent(transformedData || []),
    [transformedData]
  );
  const accessibleLevels = useMemo(
    () => transformedData
      .filter(item => hasAccess(user, item.level, courseSlug) && item.level !== 9999)
      .sort ((a, b) => a.level - b.level),
      [transformedData, user]
  );

  const userLevelContent = useMemo(
    () => transformedData
      .slice()
      .sort((a,b) => b.level - a.level)
      .find(item => hasAccess(user, item.level, courseSlug)),
      [transformedData,user, courseSlug]
  );

  const highestAccessibleLevel = accessibleLevels[accessibleLevels.length - 1];
  const mergedForSelected = highestAccessibleLevel 
  ? allMerged.find( item => item.level === highestAccessibleLevel.level) 
  : null;

    // console.log("TRANSFORMED DATA:", transformedData);

  return {
    selectedLevel: userLevelContent,
    mergedForSelected,
    accessibleLevels,
    userLevelContent 
  }
}  

 